module.exports = __webpack_public_path__ + "img/map_m.c841c903.png";